import BaseExtendedListViewController from '../../base/controllers/extended-list-view';
import changelogCustomTemplate from '../views/action-formats/created.tpl.html';
import moment from 'moment';

export default class ActionLogExtendedListViewController extends BaseExtendedListViewController {
    constructor(model, $injector, $scope) {
        super(model, $injector, $scope);
        this.translate = $injector.get('$translate');
        this.parameters = {
            include: 'latestMessage,messages,latestRsvp,rsvps,latestRsvp.guestlist,picklists'
        };

        this.actionData = null;


        this._setupActionSpecialViews();
    }

    $onInit() {

    }

    setRow(row) {
        super.setRow(row);
        switch (this.row.action) {
            case 'Created':
            case 'Updated':
                this._prepareUpdatedActionData();
                break;
        }
    }

    sanitize(value) {
        return this.injector.get('$sanitize')(value);
    }

    loadData() {
        // return super.loadData().then(() => {
        //     this.contact = this.model;
        // });
    }

    _setupActionSpecialViews() {
        this.actionSpecialViews = {
            Created: changelogCustomTemplate,
            Updated: changelogCustomTemplate,
        };
    }

    _prepareUpdatedActionData() {
        const displayData = _.cloneDeep(this.row.meta_data);

        _.each(displayData, (contents, field) => {
            if (!_.isUndefined(contents.values.old)) {
                contents.values.old = this._transformValueForType(contents.values.old, contents.type);
            }
            if (!_.isUndefined(contents.values.new)) {
                contents.values.new = this._transformValueForType(contents.values.new, contents.type);
            }
        });

        this.actionData = displayData;
    }

    _transformValueForType(rawValue, type) {
        switch (type) {
            case 'bool':
                return rawValue ? this.translate.instant('general.verbs.yes') : this.translate.instant('general.verbs.no');
            case 'date':
                return moment(rawValue).format('D.M.Y');
            case 'datetime':
                return moment(rawValue).format('Y-M-D HH:mm:ss');
            case 'string':
                return rawValue + '';
            case 'multi_select':
                return rawValue.join(', ');
            case 'integer':
                return parseInt(rawValue);
            case 'float':
                return;
            default:
                console.info('No transformer for type "' + type + '" defined');
                return rawValue;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/store/action_log/controllers/extended-list-controller.js